import { isNotDefined } from '@sgme/fp';

import { initiateCheckFlexiForwardByTradeCapture } from '@/store/flexi-forward/api';
import { generateEmptyFlexiForwardTile } from '@/store/flexi-forward/helpers/tile.ts';
import { selectFlexiForwardTile } from '@/store/flexi-forward/selectors/tile.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

export const registerDuplicateFlexiForwardTradeCaptureListeners = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const state = api.getState();

      const { sourceTileId, newTileId } = action.payload;

      const sourceTile = selectFlexiForwardTile(state, sourceTileId);

      if (isNotDefined(sourceTile)) {
        return;
      }

      const { rfs: _, ...tilePropertiesWithoutRfs } = sourceTile.properties;

      const newFlexiForwardTile = generateEmptyFlexiForwardTile(
        newTileId,
        tilePropertiesWithoutRfs,
        sourceTile.clientId,
      );

      api.dispatch(initiateCheckFlexiForwardByTradeCapture({ tileId: newTileId, ...newFlexiForwardTile }));
    },
  });
};
